import React from 'react';
import { Link } from 'react-router-dom';
import { brand } from '../config/brand';
import postmanLogo from '../assets/postman-logo-transparent.png';
import { useLanguage } from '../i18n/LanguageContext';

function Footer() {
  const { t } = useLanguage();
  return (
    <footer className="site-footer">
      <div className="shell footer-grid">
        <div className="footer-brand">
          <Link to="/" aria-label={t.header.homeLabel}>
            <img src={postmanLogo} alt="POSTMAN" className="footer-logo" />
          </Link>
          <p>{t.footer.description}</p>
        </div>
        <div>
          <p className="footer-title">{t.footer.navigation}</p>
          <div className="footer-links">
            <Link to="/tracking">{t.footer.trackShipment}</Link>
            <Link to="/services">{t.common.services}</Link>
            <Link to="/contacts">{t.common.contacts}</Link>
            <a href={brand.cabinetUrl} target="_blank" rel="noreferrer">{t.common.cabinet}</a>
          </div>
        </div>
        <div>
          <p className="footer-title">{t.footer.contact}</p>
          <div className="footer-links">
            <a href={brand.contact.phoneHref}>{brand.contact.phone}</a>
            <a href={`mailto:${brand.contact.email}`}>{brand.contact.email}</a>
            <span>{t.contactsPage.address}</span>
          </div>
        </div>
      </div>
      <div className="shell footer-bottom">
        <span>© {new Date().getFullYear()} {t.footer.company}</span>
        <a className="footer-credit" href="https://vinci.kz" target="_blank" rel="noreferrer">
          {t.footer.madeBy} <strong>VINCI</strong><span aria-hidden="true">↗</span>
        </a>
        <Link to="/privacy">{t.footer.privacy}</Link>
      </div>
    </footer>
  );
}

export default Footer;
